export default __webpack_public_path__ + "static/media/tradeshow.1ac53938.png";